import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {UtilsService} from "../../../core/utils/utils.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {PointDeLivraisonService} from "../../../core/services/entities/point-de-livraison.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {TagBoxComponent} from "../../../shared/ui/tag-box/tag-box.component";
import {PointDeLivraisonDTO} from "../../../core/dtos/point-de-livraison-d-t-o";
import {Subscription} from "rxjs";
import {PointTeledeclarationEgalimDto} from "../../../core/dtos/egalim/point-teledeclaration-egalim-dto";
import {PointTeledeclarationEgalimService} from "../../../core/services/entities/point-teledeclaration-egalim.service";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-point-teledeclaration-egalim-edition',
    templateUrl: './point-teledeclaration-egalim-edition.component.html',
    styleUrls: ['./point-teledeclaration-egalim-edition.component.scss'],
    standalone: false
})
export class PointTeledeclarationEgalimEditionComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @ViewChild("plcList") plcListTagBox: TagBoxComponent;

  pointTeledeclaration: PointTeledeclarationEgalimDto;

  form: FormGroup = new FormGroup({});

  dialogTitle: String;

  displayDialog = false;

  sitePlaceholder: String;

  allPlcs: PointDeLivraisonDTO[] = [];
  selectedPlcs: number[] = [];

  selectedSite: SiteDTO;

  subOpenDialog: Subscription
  subPlcs: Subscription;

  constructor(private toastSvc: ToastService,
              public pointDeLivraisonSvc: PointDeLivraisonService,
              public pointTeledeclarationEgalimSvc: PointTeledeclarationEgalimService,
              public utilsSvc: UtilsService,
              private auth2Svc: Auth2Service) {
  }

  ngOnInit(): void {
    this.globalInit();
    this.openDialogEditionSubscription();
  }

  globalInit = (): void => {
    this.selectedPlcs = this.utilsSvc.isCollectionNullOrEmpty(this.pointTeledeclaration?.pointLivraisonClientList) ? [] : this.pointTeledeclaration?.pointLivraisonClientList.map(plc => plc.id);
    this.initAllPlcs();
    this.initForm();
  }

  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.pointTeledeclarationEgalimSvc.openDialogEditionPointTeledeclarationEgalim$
      .subscribe((pte: PointTeledeclarationEgalimDto) => {
        this.displayDialog = true;
        if (!pte) {
          this.pointTeledeclaration = new PointTeledeclarationEgalimDto();
          this.pointTeledeclaration.id = 0;
          this.dialogTitle = 'Création d\'un point de télédeclaration Ma Cantine';
        } else {
          this.pointTeledeclaration = pte;
          this.dialogTitle = 'Modification d\'un point de télédeclaration Ma Cantine';
        }
        this.globalInit();
      });
  };


  closeDialog = (): void => {
    this.displayDialog = false;
  };

  initAllPlcs = (): void => {
    this.subPlcs = this.pointDeLivraisonSvc.findAllPlcList( null, false, true,
      this.selectedPlcs ? this.selectedPlcs : []).subscribe(response => {
      this.allPlcs = response.allPointLivraison;
    });
  }

  isFormValide = (): boolean => {
    return this.form.valid && this.plcListTagBox.getSelectedItems().length > 0 && !this.utilsSvc.isNullOrEmpty(this.selectedSite)
  }

  save = (): void => {
    if (this.isFormValide()) {

      this.pointTeledeclaration.site = {id: this.selectedSite?.id, libelle: this.selectedSite?.libelle} as SiteDTO;
      this.pointTeledeclaration.libelle = this.form.controls['libelle'].value;
      this.pointTeledeclaration.code = this.form.controls['code'].value;
      this.pointTeledeclaration.actif = this.form.controls['actif'].value;
      this.pointTeledeclaration.siret = this.form.controls['siret'].value;
      this.pointTeledeclaration.emailAddress = this.form.controls['emailAddress'].value;
      this.pointTeledeclaration.pointLivraisonClientList = this.plcListTagBox.getSelectedItems();


      this.pointTeledeclarationEgalimSvc.savePointTeledeclarationEgalim(this.pointTeledeclaration).subscribe((response) => {
        if (!this.utilsSvc.isResponseSupplierError(response)) {
          const isUpdate = this.pointTeledeclaration.id !== null && this.pointTeledeclaration.id !== undefined && this.pointTeledeclaration.id !== 0;
          this.pointTeledeclarationEgalimSvc.announcePointTeledeclarationEgalimSaved(response.one, isUpdate);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Point de facturation enregistré avec succès`);
        }
      })
      this.closeDialog();
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  };

  initForm = (): void => {
    this.sitePlaceholder = !this.canModify() ? this.pointTeledeclaration?.site?.libelle : 'Selectionner le site...';
    this.selectedSite = this.pointTeledeclaration?.site;
    this.form = new FormGroup({
      libelle: new FormControl(this.pointTeledeclaration?.libelle, [Validators.required]),
      code: new FormControl(this.pointTeledeclaration?.code, [Validators.required]),
      actif: new FormControl(this.pointTeledeclaration?.actif != null ? this.pointTeledeclaration.actif : true),
      siret: new FormControl(this.pointTeledeclaration?.siret, [Validators.required]),
      emailAddress: new FormControl(this.pointTeledeclaration?.emailAddress)
    });
  };

  findAllLocalSites = (): SiteDTO[] => {
    return this.auth2Svc.utilisateur.siteListLocaux;
  }

  onChangeSite = ($event: any): void => {
    this.selectedSite = $event.selectedItem;
  }

  canModify = () => {
    return this.pointTeledeclarationEgalimSvc.canModify(this.pointTeledeclaration);
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
    this.utilsSvc.unsubscribe(this.subPlcs);
  }
}
